/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Acquisitionmultiplicatorperson2Inputs */

const de__field_acquisitionmultiplicatorperson2 = /** @type {(inputs: _Field_Acquisitionmultiplicatorperson2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Multiplikatorperson`)
};

/**

* @param {_Field_Acquisitionmultiplicatorperson2Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_acquisitionmultiplicatorperson2 = /** @type {((inputs?: _Field_Acquisitionmultiplicatorperson2Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Acquisitionmultiplicatorperson2Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_acquisitionmultiplicatorperson2(inputs)
});
export { _field_acquisitionmultiplicatorperson2 as "_field_acquisitionMultiplicatorPerson" }